import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingNewVsReturningStudentsAPI = async (params: {
  sessionId?: string;
  startDate?: string;
  endDate?: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>('/reporting/new-vs-returning', {
    params,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingNewVsReturningStudents = (params: {
  sessionId?: string;
  startDate?: string;
  endDate?: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [
      KEYS.NEW_VS_RETURNING_STUDENTS_REPORT,
      params.sessionId ?? '',
      params.startDate ?? '',
      params.endDate ?? '',
      params.format,
    ],
    queryFn: () => reportingNewVsReturningStudentsAPI(params),
    enabled:
      !!params.format &&
      (Boolean(params.sessionId) ||
        Boolean(params.startDate) ||
        Boolean(params.endDate)),
  });
};
